module.exports = __webpack_public_path__ + "img/bio-photo-03.f6761404.jpg";